<div class="wrapper">

  <ng-container *ngIf="!trial; else trialInfo">
  <span
    class="non-trial-status"
    [innerHtml]="'PLANS.CURRENT_PLAN_INFO' | translate: {users: firstPlan.quantity, plan: firstPlan.planName}"></span>
    <h1 class="top-info-title" translate>NOTIFICATION.TRIAL.MODIFY_SUBSCRIPTION</h1>
  </ng-container>

  <ng-template #trialInfo>
    <h1 class="top-info-title" translate>NOTIFICATION.TRIAL.CHOOSE_PLAN</h1>
    <span *ngIf="!subscriptionExpired"
          class="top-info-text"
          [innerHtml]="'NOTIFICATION.TRIAL.INFO' | translate:{time: remainingTime}"></span>
    <span *ngIf="subscriptionExpired"
          class="top-info-text"
          [innerHtml]="'NOTIFICATION.TRIAL.EXPIRED' | translate:{time: remainingTime}"></span>
  </ng-template>
</div>
